import { differenceBy } from 'lodash';
import {
    STOCK_PROCESS_DATA_BEGIN,
    STOCK_PROCESS_DATA_SUCCESS,
    STOCK_PROCESS_DATA_FAILURE
} from './constants';
import { BFFAgent } from '../../../common/BFFAgent';
import { cloneDeep, capitalize } from "lodash"

function orderDetailList(detailedList, schema, order) {
    let detailedListOrdered = []

    for (let i = 0; i < order.length; i++) {
        const key = order[i]

        for (let j = 0; j < detailedList.length; j++) {
            const dl = detailedList[j]
            if (dl.name === schema[key].name) {
                detailedListOrdered.push(dl)
            }
        }
    }

    return detailedListOrdered
}

export function processData() {
    return async (dispatch, getState) => {
        dispatch({
            type: STOCK_PROCESS_DATA_BEGIN,
        });

        const PURCHASE_DATE_FUTURE = 1, VIN_REPEATED = 3, VIN_EMPTY = 4, VIN_INCORRECT = 5, WITHOUT_ORIGIN = 6, PURCHASE_DATE_INVALID = 7, BUSINESS_UNIT_EMPTY_OR_INVALID = 8, STATE_EMPTY_OR_INVALID = 9, VIN_EXISTS_SAME_VALUES = 10, VIN_EXISTS_BRANCHOFFICE = 11, VIN_EXISTS_LOCATION = 12, BRANCH_OFFICE_INVALID = 13, VIN_EXISTS_STATE = 14, VIN_EXISTS_DIFFERENT_CARLOT = 15, VIN_EXISTS_DIFFERENT_BRAND = 16, VIN_EXISTS_DIFFERENT_MODEL = 17, VIN_EXISTS_DIFFERENT_COLOR = 18, VIN_EXISTS_DIFFERENT_OWNER = 19, VIN_EXISTS_DIFFERENT_BRANCHOFFICE = 20, VIN_EXISTS_DIFFERENT_PURCHASE_DATE = 21, VIN_EXISTS_DIFFERENT_VERSION = 22;
        const CARLOT = 'carLot', VIN = 'vin', PURCHASEDATE = 'purchaseDate', BUSINESS_UNIT = 'businessUnit', STATE = 'state', BRANCH_OFFICE = 'branchOffice', LOCATION = 'location', BRAND = 'brand', MODEL = 'model', VERSION = 'version', COLOR = 'color', OWNER = 'productOwner';
        let quantityRepeated = 0, quantityVINIncorrect = 0, quantityPurchaseDateFuture = 0, quantityPurchaseDateInvalid = 0, quantityVINEmpty = 0, quantityWithoutOrigin = 0, quantityBusinessUnitEmptyOrInvalid = 0, quantityStateEmptyOrInvalid = 0, quantityVINExistsSameValues = 0, quantityVINExistsBranchOffice = 0, quantityVINExistsLocation = 0, quantityBranchOfficeInvalid = 0, quantityVINExistsState = 0, quantityVINExistDifferentCarlot = 0, quantityVINExistDifferentBrand = 0, quantityVINExistDifferentModel = 0, quantityVINExistDifferentVersion = 0, quantityVINExistDifferentColor = 0, quantityVINExistDifferentOwner = 0, quantityVINExistDifferentBranchoffice = 0, quantityVINExistDifferentPurchaseDate = 0;
        const { stock: { translator, stocks, carLotPermissions, schema, carLotNotSelected, stockToProcess } } = getState();
        const translatorKeys = Object.keys(translator);
        let stockToProcessClone = cloneDeep(stockToProcess)
        stockToProcessClone = stockToProcessClone.filter(stock => !stock.hasNonEquivalence);
        stockToProcessClone.forEach(stock => delete stock.hasNonEquivalence)
        try {
            const doRequestStock = await BFFAgent.Stock.checkStockMassiveUpload(stockToProcess);
            const { error } = doRequestStock;
            error.forEach(err => {
                let stockFind = stocks.find(s => s.index === err.index);
                stockFind.error ? stockFind.error.push(err.error) : stockFind.error = [err.error];
                switch (err.kind) {
                    case PURCHASE_DATE_FUTURE:
                        quantityPurchaseDateFuture++;
                        break;
                    case PURCHASE_DATE_INVALID:
                        quantityPurchaseDateInvalid++;
                        break;
                    case VIN_REPEATED:
                        quantityRepeated++;
                        break;
                    case VIN_EMPTY:
                        quantityVINEmpty++;
                        break;
                    case VIN_INCORRECT:
                        quantityVINIncorrect++;
                        break;
                    case WITHOUT_ORIGIN:
                        quantityWithoutOrigin++;
                        break;
                    case BUSINESS_UNIT_EMPTY_OR_INVALID:
                        quantityBusinessUnitEmptyOrInvalid++;
                        break;
                    case STATE_EMPTY_OR_INVALID:
                        quantityStateEmptyOrInvalid++;
                        break;
                    case VIN_EXISTS_SAME_VALUES:
                        quantityVINExistsSameValues++;
                        break;
                    case VIN_EXISTS_BRANCHOFFICE:
                        quantityVINExistsBranchOffice++;
                        break;
                    case BRANCH_OFFICE_INVALID:
                        quantityBranchOfficeInvalid++;
                        break;
                    case VIN_EXISTS_LOCATION:
                        quantityVINExistsLocation++;
                        break;
                    case VIN_EXISTS_STATE:
                        quantityVINExistsState++;
                        break;
                    case VIN_EXISTS_DIFFERENT_CARLOT:
                        quantityVINExistDifferentCarlot++;
                        break;
                    case VIN_EXISTS_DIFFERENT_BRAND:
                        quantityVINExistDifferentBrand ++;
                        break;
                    case VIN_EXISTS_DIFFERENT_MODEL:
                        quantityVINExistDifferentModel ++;
                        break;
                    case VIN_EXISTS_DIFFERENT_VERSION :
                        quantityVINExistDifferentVersion ++;
                        break;
                    case VIN_EXISTS_DIFFERENT_COLOR :
                        quantityVINExistDifferentColor ++;
                        break;
                    case VIN_EXISTS_DIFFERENT_OWNER :
                        quantityVINExistDifferentOwner ++;
                        break;
                    case VIN_EXISTS_DIFFERENT_BRANCHOFFICE :
                        quantityVINExistDifferentBranchoffice ++;
                        break;
                    case VIN_EXISTS_DIFFERENT_PURCHASE_DATE :
                         quantityVINExistDifferentPurchaseDate++;
                        break;
                    default:
                        break;
                }
            })


        let carLotWithoutPermission = carLotPermissions.filter(carLot => !carLot.authorized);

        let stockWithoutPermission = [];
        carLotWithoutPermission.forEach(carLot => {
            const stockFiltered = stocks.filter(stock => stock.carLot === carLot.carLotName);
            if (stockFiltered.length) {
                stockWithoutPermission.push(...stockFiltered);
            }
        })

        stockWithoutPermission.forEach(stock => {
            stock.error ? stock.error.push("No tenés permisos para este concesionario.")
                : stock.error = ["No tenés permisos para este concesionario."];
        })


        let stockNotSelected = differenceBy(carLotNotSelected, stockWithoutPermission, 'carLot');
        stockNotSelected = differenceBy(stockNotSelected, stockToProcessClone, 'carLot');
        stockNotSelected.forEach(stock => {
            const errorMessage = "Concesionario no confirmado para importación."
            stock.error ? stock.error.push(errorMessage)
                : stock.error = [errorMessage];
        })

        let summary = {
            carInfo: {
                carsToRegister: 0,
                total: stocks.length
            },
            quantityErrorData: 0,
            detailedList: []
        };



        if (stockWithoutPermission.length) {
            summary.detailedList.push({
                name: schema[CARLOT].name,
                value: stockWithoutPermission.length === 1
                    ? '1 auto está dentro de un concesionario al que no tenes permisos.'
                    : `${stockWithoutPermission.length} autos están dentro de un concesionario al que no tenes permisos.`
            })
        }

        if (stockNotSelected.length) {
            summary.detailedList.push({
                name: schema[CARLOT].name,
                value: stockNotSelected.length === 1
                    ? '1 auto está dentro de un concesionario que no fue seleccionado.'
                    : `${stockNotSelected.length} autos están dentro de un concesionario que no fue seleccionado.`
            })
        }

        translatorKeys.forEach(translatorKey => {
            const attributeName = capitalize(schema[translatorKey].name)
            const quantity = stocks?.filter(stock => stock?.error?.includes(`El atributo ${attributeName} está sin validar.`))
            if (quantity && quantity.length > 0) {
                summary.detailedList.push({
                    name: schema[translatorKey].name,
                    value: quantity.length === 1
                        ? `1 auto tiene el atributo ${(schema[translatorKey].name).toLowerCase()} sin equivalencia.`
                        : `${quantity.length} autos tienen el atributo ${(schema[translatorKey].name).toLowerCase()} sin equivalencia.`
                })
            }
        })

        if (quantityRepeated) {
            summary.detailedList.push({
                name: schema[VIN].name,
                value: quantityRepeated === 1
                    ? `1 registro tiene el ${schema[VIN].name} repetido en el archivo importado.`
                    : `${quantityRepeated} registros tienen el ${schema[VIN].name} repetido en el archivo importado.`
            })
        }

        if (quantityVINExistsSameValues) {
            summary.detailedList.push({
                name: schema[VIN].name,
                value: quantityVINExistsSameValues === 1
                    ? `${quantityVINExistsSameValues} auto no se puede actualizar porque el stock ya contiene la misma información que el archivo.`
                    : `${quantityVINExistsSameValues} autos no se pueden actualizar porque el stock ya contiene la misma información que el archivo.`
            })
        }

        if (quantityVINExistsBranchOffice) {
            summary.detailedList.push({
                name: schema[BRANCH_OFFICE].name,
                value: quantityVINExistsBranchOffice === 1
                    ? `${quantityVINExistsBranchOffice} auto no se puede actualizar porque la sucursal no pertenece a la concesionaria actual del VIN`
                    : `${quantityVINExistsBranchOffice} autos no se pueden actualizar porque la sucursal no pertenece a la concesionaria actual del VIN`
            })
        }

        if (quantityBranchOfficeInvalid) {
            summary.detailedList.push({
                name: schema[BRANCH_OFFICE].name,
                value: quantityBranchOfficeInvalid === 1
                    ? `1 auto tiene el campo ${schema[BRANCH_OFFICE].name} con un valor no válido o inexistente para el concesionario.`
                    : `${quantityBranchOfficeInvalid} autos tienen el campo ${schema[BRANCH_OFFICE].name} con un valor no válido o inexistente para el concesionario.`
            })
        }

        if (quantityVINExistsLocation) {
            summary.detailedList.push({
                name: schema[LOCATION].name,
                value: quantityVINExistsLocation === 1
                    ? `${quantityVINExistsLocation} auto no se puede actualizar porque la ubicación no se corresponde con la sucursal y concesionaria actual del VIN.`
                    : `${quantityVINExistsLocation} autos no se pueden actualizar porque la ubicación no se corresponde con la sucursal y concesionaria actual del VIN.`
            })
        }

        if (quantityVINExistsState) {
            summary.detailedList.push({
                name: schema[STATE].name,
                value: quantityVINExistsState === 1
                    ? `${quantityVINExistsState} auto no se puede actualizar porque su estado actual no lo permite.`
                    : `${quantityVINExistsState} autos no se pueden actualizar porque su estado actual no lo permite.`
            })
        }

        if (quantityVINExistDifferentCarlot) {
            summary.detailedList.push({
                name: schema[CARLOT].name,
                value: quantityVINExistDifferentCarlot === 1
                    ? `${quantityVINExistDifferentCarlot} auto no se actualizará porque no está permitido editar el ${schema[CARLOT].name}`
                    : `${quantityVINExistDifferentCarlot} autos no se actualizarán porque no está permitido editar el ${schema[CARLOT].name}`
            })
        }

        if (quantityVINExistDifferentBrand) {
            summary.detailedList.push({
                name: schema[BRAND].name,
                value: quantityVINExistDifferentBrand === 1
                    ? `${quantityVINExistDifferentBrand} auto no se actualizará porque no está permitido editar la ${schema[BRAND].name}`
                    : `${quantityVINExistDifferentBrand} autos no se actualizarán porque no está permitido editar la ${schema[BRAND].name}`
            })
        }

        if (quantityVINExistDifferentModel) {
            summary.detailedList.push({
                name: schema[MODEL].name,
                value: quantityVINExistDifferentModel === 1
                    ? `${quantityVINExistDifferentModel} auto no se actualizará porque no está permitido editar el ${schema[MODEL].name}`
                    : `${quantityVINExistDifferentModel} autos no se actualizarán porque no está permitido editar el ${schema[MODEL].name}`
            })
        }

        if (quantityVINExistDifferentVersion) {
            summary.detailedList.push({
                name: schema[VERSION].name,
                value: quantityVINExistDifferentVersion === 1
                    ? `${quantityVINExistDifferentVersion} auto no se actualizará porque no está permitido editar la ${schema[VERSION].name}`
                    : `${quantityVINExistDifferentVersion} autos no se actualizarán porque no está permitido editar la ${schema[VERSION].name}`
            })
        }

        if (quantityVINExistDifferentColor) {
            summary.detailedList.push({
                name: schema[COLOR].name,
                value: quantityVINExistDifferentColor === 1
                    ? `${quantityVINExistDifferentColor} auto no se actualizará porque no está permitido editar el ${schema[COLOR].name}`
                    : `${quantityVINExistDifferentColor} autos no se actualizarán porque no está permitido editar el ${schema[COLOR].name}`
            })
        }

        if (quantityVINExistDifferentOwner) {
            summary.detailedList.push({
                name: schema[OWNER].name,
                value: quantityVINExistDifferentOwner === 1
                    ? `${quantityVINExistDifferentOwner} auto no se actualizará porque no está permitido editar el ${schema[OWNER].name}`
                    : `${quantityVINExistDifferentOwner} autos no se actualizarán porque no está permitido editar el ${schema[OWNER].name}`
            })
        }

        if (quantityVINExistDifferentBranchoffice) {
            summary.detailedList.push({
                name: schema[BRANCH_OFFICE].name,
                value: quantityVINExistDifferentBranchoffice === 1
                    ? `${quantityVINExistDifferentBranchoffice} auto no se actualizará porque no está permitido editar la ${schema[BRANCH_OFFICE].name}`
                    : `${quantityVINExistDifferentBranchoffice} autos no se actualizarán porque no está permitido editar la ${schema[BRANCH_OFFICE].name}`
            })
        }

        if (quantityVINExistDifferentPurchaseDate) {
            summary.detailedList.push({
                name: schema[PURCHASEDATE].name,
                value: quantityVINExistDifferentPurchaseDate === 1
                    ? `${quantityVINExistDifferentPurchaseDate} auto no se actualizará porque no está permitido editar la ${schema[PURCHASEDATE].name}`
                    : `${quantityVINExistDifferentPurchaseDate} autos no se actualizarán porque no está permitido editar la ${schema[PURCHASEDATE].name}`
            })
        }

        if (quantityVINIncorrect) {
            summary.detailedList.push({
                name: schema[VIN].name,
                value: quantityVINIncorrect === 1
                    ? `1 auto tiene el campo ${schema[VIN].name} con el formato incorrecto.`
                    : `${quantityVINIncorrect} autos tienen el campo ${schema[VIN].name} con el formato incorrecto.`
            })
        }

        if (quantityVINEmpty) {
            summary.detailedList.push({
                name: schema[VIN].name,
                value: quantityVINEmpty === 1
                    ? `1 auto tiene el campo ${schema[VIN].name} vacío.`
                    : `${quantityVINEmpty} autos tienen el campo ${schema[VIN].name} vacío.`
            })
        }
        if (quantityPurchaseDateFuture) {
            summary.detailedList.push({
                name: schema[PURCHASEDATE].name,
                value: quantityPurchaseDateFuture === 1
                    ? `1 auto tiene asignada una ${(schema[PURCHASEDATE].name).toLowerCase()} futura.`
                    : `${quantityPurchaseDateFuture} autos tienen asignada una ${(schema[PURCHASEDATE].name).toLowerCase()} futura.`
            })
        }

        if (quantityPurchaseDateInvalid) {
            summary.detailedList.push({
                name: schema[PURCHASEDATE].name,
                value: quantityPurchaseDateInvalid === 1
                    ? `1 auto tiene asignada una ${(schema[PURCHASEDATE].name).toLowerCase()} con formato incorrecto.`
                    : `${quantityPurchaseDateInvalid} autos tienen asignada una ${(schema[PURCHASEDATE].name).toLowerCase()} con formato incorrecto.`
            })
        }

        if (quantityWithoutOrigin) {
            summary.detailedList.push({
                name: 'ORIGEN',
                value: quantityWithoutOrigin === 1
                    ? `1 auto tiene maestro sin país de origen.`
                    : `${quantityWithoutOrigin} autos tienen maestro sin país de origen.`
            })
        }

        if (quantityBusinessUnitEmptyOrInvalid) {
            summary.detailedList.push({
                name: schema[BUSINESS_UNIT].name,
                value: quantityBusinessUnitEmptyOrInvalid === 1
                    ? `1 auto tiene el campo ${(schema[BUSINESS_UNIT].name)} vacío o con un valor no válido.`
                    : `${quantityBusinessUnitEmptyOrInvalid} autos tienen el campo ${(schema[BUSINESS_UNIT].name)} vacío o con un valor no válido.`
            })
        }

        if (quantityStateEmptyOrInvalid) {
            summary.detailedList.push({
                name: schema[STATE].name,
                value: quantityStateEmptyOrInvalid === 1
                    ? `1 auto tiene el campo ${(schema[STATE].name)} vacío o con un valor no válido.`
                    : `${quantityStateEmptyOrInvalid} autos tienen el campo ${(schema[STATE].name)} vacío o con un valor no válido.`
            })
        }

        const carsToRegister = doRequestStock.stock.reduce((count, item) => {
            const exists = doRequestStock.error.some(err => err.index === item.index)
            return exists ? count : count + 1
        }, 0);

        summary.carInfo.carsToRegister = carsToRegister
        summary.quantityErrorData = stocks.length - carsToRegister

        const order = [ CARLOT, BRAND, MODEL, VERSION, BRANCH_OFFICE, OWNER, COLOR, VIN, LOCATION, PURCHASEDATE, BUSINESS_UNIT, STATE ]
        summary.detailedList = orderDetailList(summary.detailedList, schema, order)

        dispatch({
            type: STOCK_PROCESS_DATA_SUCCESS,
            data: { summary, stocks, stockToProcess: doRequestStock.stock },
        })

        } catch (error) {
            console.error('error', error)
            return dispatch({
                type: STOCK_PROCESS_DATA_FAILURE,
                data: error
            })
        }
    }

}


export function reducer(state, action) {
    switch (action.type) {
        case STOCK_PROCESS_DATA_BEGIN:
            return {
                ...state,
                processDataPending: true,
                summary: {}
            };

        case STOCK_PROCESS_DATA_SUCCESS:
            return {
                ...state,
                processDataPending: false,
                summary: action.data.summary,
                currentStep: state.steps[state.currentStep.order + 1],
                stocks: action.data.stocks,
                stockToProcess: action.data.stockToProcess
            };

        case STOCK_PROCESS_DATA_FAILURE:
            return {
                ...state,
                processDataPending: false,
                processDataError: action.data
            };

        default:
            return state;
    }
}
